/*
 * @Description: 
 * @Author: HuangYinYin
 * @Date: 2025-01-16 15:56:58
 * @FilePath: \dataview-next\src\custom-component\viewerGIS\Events\AnalysisEvents.js
 * @LastEditTime: 2025-01-20 15:20:49
 * @LastEditors: HuangYinYin
 */
export default class AnalysisEvents {
    constructor() { }

    static getEvents(viewer, comp) {
        return {
            'ViewerGIS.createSubmergenceReal': (eid, key, data, cb) => {
                if (eid !== comp.element.id) return;

                if (!data?.options?.kml) return;

                viewer.Scene.setSceneConfig({
                    default: {
                        // terrain: false,
                        // depthTest: true,
                    },
                    optimize: {
                        isRequestRender: false,
                        sunIntensity: 7,
                        imageBasedLighting: false
                    }
                });

                viewer.Analysis.removeAll();
                viewer.Plot.unloadKmlByServe({
                    kmlFile: {
                        path: data.options.kml,
                        isModels: false
                    }
                }).then(({ dataSource }) => {
                    let positions = viewer.Plot.getKmlPositions(dataSource);
                    if (positions.length === 0) return;

                    let submergence = viewer.Analysis.createSubmergenceReal(key, Object.assign({
                        positions: positions[0]
                    }, data));
                    cb && cb(submergence);
                });
                
            },
            'ViewerGIS.removeAllAnalysis': async (eid) => {
                if (eid !== comp.element.id) return;

                viewer.Analysis.removeAll();
            },
            'ViewerGIS.removeAnalysis': async (eid, key) => {
                if (eid !== comp.element.id) return;

                viewer.Analysis.remove(key);
            }
        };
    }
}